<section class="text-align-center text-12 preview-banner-colour padding-5" [ngClass]="{
				'preview-banner-collapsed': !showBanner
			}">
	<button dz-button (click)="toggleBanner()" data-cy="preview-data-banner-button">
					<dz-icon *ngIf="!showBanner" type="plus"></dz-icon>
					<dz-icon *ngIf="showBanner" type="minus"></dz-icon>
				</button>
	<span *ngIf="pasPreview && !showAsOfDate && showBanner" dcrHTMLKey="PAS_PREVIEW_BANNER_NO_DATE_TEXT">Note: You are viewing preview data</span>
	<span *ngIf="showAsOfDate && showBanner" dcrHTMLKey="PAS_PREVIEW_BANNER_WITH_DATE_TEXT" [dcrSubstitutions]="{ $asOfDate$: asOfDate }"
		>Note: You are viewing preview data with data showing as of $asOfDate$
	</span>
</section>
